/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimelineInitiator
 */
export interface TimelineInitiator {
    /**
     * 
     * @type {string}
     * @memberof TimelineInitiator
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineInitiator
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineInitiator
     */
    name: string;
}

/**
 * Check if a given object implements the TimelineInitiator interface.
 */
export function instanceOfTimelineInitiator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function TimelineInitiatorFromJSON(json: any): TimelineInitiator {
    return TimelineInitiatorFromJSONTyped(json, false);
}

export function TimelineInitiatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimelineInitiator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'name': json['name'],
    };
}

export function TimelineInitiatorToJSON(value?: TimelineInitiator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
    };
}

